import type { GetHistoryEntry } from '@repo/schema/history'
import { createContext, use } from 'react'

// What one history owner (a load, a company) adds to the shared labels.
export type HistoryEntity = {
  eventLabels?: Partial<Record<GetHistoryEntry['event'], string>>
  fieldLabels?: Record<string, string>
  name: string
  // Child record nouns by subject type, so a created child reads "<noun> added".
  subjectLabels?: Record<string, string>
}

export const HistoryEntityContext = createContext<HistoryEntity | null>(null)

export const useHistoryEntity = () => {
  const entity = use(HistoryEntityContext)
  if (!entity) throw new Error('useHistoryEntity must be used inside HistoryContent')
  return entity
}
